import React, { lazy, Suspense, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';

import TenantConfig, { getTenant, getEnv } from '../config';

const importHeaderByTenantName = (tenantName) => {
  return lazy(() => import(`./${tenantName}/Landing`).catch(() => import(`./amazon/Landing`)));
};

const Landing = () => {
  useEffect(() => {
    if (TenantConfig?.landingURL !== 'default' && getEnv() === 'production') {
      window.location.href = TenantConfig?.landingURL;
    }
  }, []);

  const HeaderFromLazy = importHeaderByTenantName(getTenant());

  return (
    <Suspense
      fallback={
        <div className="custom-spinner">
          <ClipLoader color="white" loading={true} size={70} />
        </div>
      }
    >
      <HeaderFromLazy />
    </Suspense>
  );
};

export default Landing;
